import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { resolveConnectAppDetails } from './connectAppAssistantPayloadBody.js'
import { buildConnectAppAssistantBlocks } from './connectAppAssistantPayloadBlocks.js'

export function buildConnectAssistantMessagePatch(trimmed, connectContext, thinkingStartedAtMs) {
  const details = resolveConnectAppDetails(trimmed, connectContext)
  const slug =
    (typeof connectContext?.slug === 'string' && connectContext.slug.trim()) ||
    (typeof connectContext?.toolkitSlug === 'string' && connectContext.toolkitSlug.trim()) ||
    undefined
  const blocks = buildConnectAppAssistantBlocks({ ...details, toolkitSlug: slug })
  const endedAt = Date.now()
  return {
    text: '',
    blocks,
    agentBrand: 'SIA',
    agentName: 'Master Root Agent',
    thoughtSummary: formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAt),
    createdAt: endedAt,
  }
}
